import React from 'react';
import type { TemplateConfig } from '@/mocks/template-config';
import type { CompanyData } from '@/hooks/useCompanyData';
import type { TemplatePreset } from '@/mocks/template-presets';
import TopSection from '@/pages/home/components/TopSection';
import MainImageSection from '@/pages/home/components/MainImageSection';
import InstitutionalSection from '@/pages/home/components/InstitutionalSection';
import FooterSection from '@/pages/home/components/FooterSection';
import { applyPresetToConfig } from '@/hooks/useTemplatePresets';

interface AdminPreviewProps {
  config: TemplateConfig;
  companyData: CompanyData;
  presets: TemplatePreset[];
  activePresetId: string | null;
}

export default function AdminPreview({ config, companyData, presets, activePresetId }: AdminPreviewProps) {
  const activePreset = presets.find((p) => p.id === activePresetId);
  const displayConfig = activePreset ? applyPresetToConfig(config, activePreset) : config;

  const topBannerMobile = activePreset?.topBannerMobile || displayConfig.top.bannerImage;

  return (
    <div className="bg-brand-darker rounded-lg border border-brand-gold/10 overflow-hidden flex flex-col h-full">
      <div className="px-4 py-3 border-b border-brand-gold/10 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-eye-line text-brand-gold text-sm" />
          </div>
          <span className="text-white text-sm font-medium">Preview do Template</span>
        </div>
        <span className="text-brand-text-muted text-xs">Scroll para ver tudo</span>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="min-w-[400px]">
          {/* Top + Main Image Section */}
          <div className="relative min-h-[400px] flex flex-col">
            <TopSection config={displayConfig.top} companyData={companyData} bannerMobile={topBannerMobile} />
            <div className="relative z-10 flex flex-col items-center px-4 pb-4">
              <MainImageSection config={displayConfig.mainImage} clientBoxConfig={displayConfig.clientBox} />
            </div>
          </div>
          <InstitutionalSection config={displayConfig.institutional} />
          <FooterSection config={displayConfig.footer} specialties={displayConfig.specialties} companyData={companyData} />
        </div>
      </div>
    </div>
  );
}